import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';
import { AccessCodeDetails } from '../interfaces/access-code.interface';

/*----- SELECTORS ------*/
export const getAccessCodeData = (state: StoreState): AccessCodeDetails | undefined => state.accessCodeState.data;

export const getAccessCodeStatus = (state: StoreState): ActionStatus => state.accessCodeState.status;
export const getAccessCodeProduct = (state: StoreState): string => state.accessCodeState.product;
export const isAccessCodeRedeemEligible = (state: StoreState): boolean => state.accessCodeState.redeemEligible;

